import { render } from "./WebhookEvents.vue?vue&type=template&id=238a0456"
import script from "./WebhookEvents.vue?vue&type=script&lang=js"
export * from "./WebhookEvents.vue?vue&type=script&lang=js"

import "./WebhookEvents.vue?vue&type=style&index=0&id=238a0456&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__